module.exports = __webpack_public_path__ + "img/PlacesToGoPR.com.84cb156b.svg";